<router-outlet />
<section
  *ngIf="showSessionTimer()"
  style="position:fixed; right:16px; bottom:16px; z-index:1100; background:#fff; border:1px solid #d6dbe5; border-radius:10px; padding:10px 12px; box-shadow:0 8px 24px rgba(15,23,42,0.12); max-width:320px;"
>
  <div style="font-size:13px; color:#1f2b3d; margin-bottom:8px;">
    Sessione in scadenza tra <strong>{{ sessionRemainingSeconds() }}</strong>s.
  </div>
  <button
    type="button"
    (click)="keepSessionAlive()"
    style="border:0; border-radius:8px; background:#2f76f2; color:#fff; padding:6px 10px; font-size:13px; font-weight:700; cursor:pointer;"
  >
    Aggiorna sessione
  </button>
</section>
<app-notification-host />
